import { createSelector } from 'reselect';

export const selectRootQuestions = (state) => state.questions;

export const selectQuestions = createSelector(
  selectRootQuestions,
  (rootQuestions) => rootQuestions.questions,
);

export const selectRetrievedQuestions = createSelector(
  selectQuestions,
  (questions) => questions.RETRIEVED_QUESTIONS,
);

export const questionsSelectors = {
  selectRetrievedQuestions,
};
